export const normaliseCarouselItemHeights = (carousel) => {
  if (carousel) {
    let globalMaxHeight = 0;

    // 1. Reset all cells to their natural height before recalculating the max height
    carousel.slides.forEach((slide) => {
      slide.cells.forEach((cell) => {
        cell.element.style.height = 'auto';
      });
    });

    // 2. Find the tallest cell in the entire carousel
    carousel.slides.forEach((slide) => {
      slide.cells.forEach((cell) => {
        const itemHeight = cell.element.offsetHeight;
        if (itemHeight > globalMaxHeight) {
          globalMaxHeight = itemHeight;
        }
      });
    });

    // 3.Set all cells to the height of the tallest cell found
    carousel.slides.forEach((slide) => {
      slide.cells.forEach((cell) => {
        cell.element.style.height = `${globalMaxHeight}px`;
      });
    });
  }
};
